import React, { Component, Fragment } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import {hit} from '../../metrics';
import CaseFooterNew from '../CaseFooterNew';
import HelmetSite from '../HelmetSite';
import './style.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "../../../../node_modules/swiper/swiper-bundle.min.css";

class Dreamriva extends Component{
  swiperRef = React.createRef();
  swiperRef2 = React.createRef();
  state = {
		preview: true,
		play: false,
		mobile: window.innerWidth <= 1000
	};

	resize = () => this.setState({mobile: window.innerWidth <= 1000})

	componentDidMount(){
    var video = document.getElementById("video");
    $(".videoBlock__btn").click(function () {
      $(".videoBlock__btn").toggleClass("videoBlock__btn_hidden");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
		if(this.props.pathname == '/projects/dreamriva/'){
			this.setState({preview: false});
			this.props.setProjectName('dreamriva');
			$('body').addClass('case-expanded hash-dreamriva');
			$(window).scrollTop($('#case-dreamriva').offset().top);
			this.props.changeCase(null);
		}
		else{
			this.setState({preview: true});
			$('body').removeClass('hash-dreamriva');
    }
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    setTimeout(() => {
			$('body').addClass('fadepage');
    }, 100);
	}

	componentDidUpdate(){
		if(this.props.pathname == '/projects/'){
			$('body').removeClass('case-expanded hash-dreamriva');
		}
  }

  componentWillUnmount() {
    $('body').removeClass('fadepage');
  }
  
	render(){
		return(
		<div className='case'>
			<div className="case-content" id="case-dreamriva">

        <div className="screen">
          <div className="topScreen">
            <div className="topScreen__bg" style={{backgroundImage: `url('/cases/img/dreamriva/bg-top.webp')`}} />
            <div className="topScreen__logo"><img src="/cases/img/dreamriva/logo.svg" alt="" /></div>
          </div>
          <div className="aboutProject">
            <div className="content">
              <div className="aboutProject__wrap">
                <div className="aboutProject__left">
                  <div className="aboutProject__title title">Жилой комплекс “Dream Riva”</div>
                  <div className="aboutProject__desc">
                    <div>
                      <div>Клиент</div>
                      <div>Regions Development</div>
                    </div>
                    <div>
                      <div>Виды&nbsp;работ</div>
                      <div>
                        <div className="tabs">
                          <div>Сайт</div>
                        </div>
                      </div>
                    </div>            
                  </div>     
                </div>                
                <div className="aboutProject__text text">
                  Дизайн сайта развивает фирменный стиль, делая его живым и динамичным. Фоновые видео с водой, анимированные волны и тщательно подобранные изображения создают атмосферу лёгкости и курортного отдыха. Белый цвет и оттенки бирюзы подчёркивают чистоту и свежесть визуального языка.
                  <br/><br/>
                  Пространство организовано так, чтобы обеспечить лёгкость восприятия и удобство навигации. Интуитивные элементы интерфейса и воздушная композиция делают взаимодействие с сайтом естественным и комфортным.
                </div>           
              </div>         
            </div>
          </div>
        </div>
        <div className="screen">
          <div className="gridBox gridBox_style">
            <div className="gridBox__item gridBox__item_1" style={{backgroundImage: `url('/cases/img/dreamriva/water.webp')`}}>
              {!this.state.mobile && (<video playsInline autoPlay poster="/cases/img/dreamriva/videoforme.webp" muted loop>
                <source src="/cases/img/dreamriva/wbg1.mp4" type="video/mp4" />
              </video>)}
              <div className="image">
                <video playsInline autoPlay poster="/cases/img/dreamriva/videoforme.webp" muted loop>
                  <source src="/cases/img/dreamriva/wbg1.mp4" type="video/mp4" />
                </video>
                <img src="/cases/img/dreamriva/img1.webp" alt="" />
              </div>
            </div>
            <div className="gridBox__item gridBox__item_2" style={{backgroundImage: `url('/cases/img/dreamriva/img2.webp')`}}></div>
            <div className="gridBox__item gridBox__item_3" style={{backgroundImage: `url('/cases/img/dreamriva/img3.webp')`}}></div>
            <div className="gridBox__item gridBox__item_4">
              <div className="gridChild">
                <div className="gridChild__item gridChild__item_1" style={{backgroundImage: `url('/cases/img/dreamriva/img4.webp')`}}></div>
                <div className="gridChild__item gridChild__item_2" style={{backgroundImage: `url('/cases/img/dreamriva/img12.webp')`}}></div>             
              </div>
            </div>
            <div className="gridBox__item gridBox__item_5" style={{backgroundImage: `url('/cases/img/dreamriva/img5.webp')`}}></div>
            <div className="gridBox__item gridBox__item_6" style={{backgroundImage: `url('/cases/img/dreamriva/img13.webp')`}}></div>
            <div className="gridBox__item gridBox__item_7" style={{backgroundImage: `url('/cases/img/dreamriva/img14.webp')`}}></div>
            <div className="gridBox__item gridBox__item_8">
              <div className="gridChild2">
                <div className="gridChild2__item gridChild2__item_1" style={{backgroundImage: `url('/cases/img/dreamriva/img6.webp')`}}></div>
                <div className="gridChild2__item gridChild2__item_2">
                  <div className="oasis">
                    <div className="oasis__title">Оазис премиум–класса</div>
                    <div className="oasis__text">Сервисы на уровне мировых отелей, привилегии пользования общественными пространствами, приватные мероприятия. Всё, чтобы получать впечатления, о которых другие могут лишь мечтать.</div>
                    <img src="/cases/img/dreamriva/oasis.webp" alt="" />
                    <div className="oasis__desc">Уже хотите воспользоваться привилегиями?<br/>Мы ждём вашу заявку!</div>
                    <div className="oasis__btn">Оставьте заявку</div>                   
                  </div>             
                </div>             
              </div>
            </div>
            <div className="gridBox__item gridBox__item_10">
              <div className="videoBlock">
                <div className="videoBlock__btn" style={{ backgroundImage: `url('/cases/img/dreamriva/play.svg')` }}></div>
                <video id="video" poster="/cases/img/dreamriva/poster.webp" loop preload="metadata">
                  <source src="/cases/img/dreamriva/video.mp4" type="video/mp4"></source>
                </video>
              </div>                
            </div>
            <div className="gridBox__item gridBox__item_11">
              <div className="gridSmall">
                <div className="gridSmall__img" style={{backgroundImage: `url('/cases/img/dreamriva/water.webp')`}}>
                  {!this.state.mobile && (<video playsInline autoPlay poster="/cases/img/dreamriva/videoforme.webp" muted loop>
                    <source src="/cases/img/dreamriva/wbg1.mp4" type="video/mp4" />
                  </video>)}
                  <div className="image">
                    <video playsInline autoPlay poster="/cases/img/dreamriva/videoforme.webp" muted loop>
                      <source src="/cases/img/dreamriva/wbg1.mp4" type="video/mp4" />
                    </video>
                    <img src="/cases/img/dreamriva/img11.webp" alt="" />
                  </div>
                </div>
                <div className="gridSmall__text text">
                  Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко всем необходимым функциям в любое время и в любом месте. 
                  <br/><br/>
                  Интерфейс оптимизирован для удобства использования на мобильных устройствах, что делает навигацию простой и интуитивной. При этом визуальный дизайн сохраняет эстетическую привлекательность, отражая фирменный стиль проекта и создавая гармоничное восприятие даже на&nbsp;небольших экранах.
                </div>
              </div>
            </div>
            <div className="gridBox__item gridBox__item_12">
              <img src="/cases/img/dreamriva/img7.webp" alt="" />
              <img src="/cases/img/dreamriva/img8.webp" alt="" />
              <img src="/cases/img/dreamriva/img9.webp" alt="" />
              <img src="/cases/img/dreamriva/img10.webp" alt="" />
            </div>
          </div>
        </div>
			</div>

  

    <CaseFooterNew 
				to={ this.props.next ? this.props.next.url: "/projects/one/"  }
				title= { this.props.next ? this.props.next.name: "One" }
				img={ this.props.next ? this.props.next.imgCaseBottom: "/cases/img/one/projects-card.webp" }
        full={true}
			/>
      <HelmetSite title='Жилой комплекс “Dream Riva”' />

			<div className="case-info">
				<Link to="/projects/" className="all-title">Все проекты</Link>
				<div className="title">Клубный дом “Annabel’s”</div>
				<div className="tags"><span>фирменный стиль</span><span>сайт</span></div>
			</div>
		</div>
		)
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Dreamriva)
